export default __webpack_public_path__ + "static/media/html.10080bf9.svg";